import {createContext} from 'react'

export const ProductReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {} as any,
  onSearch: (value: string) => {},
  onDaysChange: (value: string) => {},
  onPurchaserChange: (value: string) => {},
  onHideDiscontinuedChange: (value: boolean) => {},
  purchasers: [] as any[],
  isPurchasersLoading: false,
  pagination: {} as any,
  onPageChange: (page: number) => {},
  onSortingChange: (value: string, direction: string) => {},
  onDownloadCsv: () => {},
  isFetchingCsvData: false,
})
